export default "__VITE_ASSET__BKtoLenF__"